<template>

  <v-app>
    <div v-if="! authenticated">
      <v-toolbar app class="white toolbar-app">
        <v-toolbar-title>
          <h1 class="pa-3 pt-4">
            <img :src="logo" width="120" height="80" />
          </h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </div>
    <div v-if="authenticated">
      <v-toolbar flat app class="toolbar-app">
        <v-toolbar-side-icon @click="drawer = ! drawer"></v-toolbar-side-icon>
        <v-toolbar-title class="text-uppercase" v-html="$route.meta.title" @click="$vuetify.goTo(0)"></v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-navigation-drawer v-model="drawer" app>
          <h1 class="pa-3 navigation-logo">
            <img :src="logo" />
          </h1>
        <v-list>
          <template v-for="(item, index) in allowedNavItems">
            <router-link :to="item.path" v-bind:key="item.path" class="red">
              <v-list-tile
                :key="item.title"
                :class="{ 'grey lighten-4' : item.path === $route.path }"
              >
                <v-list-tile-action>
                  <v-icon :color="item.path === $route.path ? 'blue darken-1' : ''">{{ item.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="grey--text text--darken-2" :class="{'primary--text' : item.path === $route.path }">{{ item.title }}</v-list-tile-title>
                  <v-list-tile-sub-title v-show="item.subtitle" class="grey--text">{{ item.subtitle }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </router-link>
            <v-divider v-bind:key="'divider-'+ index"></v-divider>
          </template>
        </v-list>
        <v-toolbar flat class="transparent pt-3" v-if="authenticated">
          <v-list class="pa-0">
            <v-list-tile>
              <v-list-tile-avatar color="grey lighten-3">
                <v-icon>person</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ user.first_name }} {{ user.last_name }}</v-list-tile-title>
                <v-list-tile-sub-title class="caption">{{ user.email }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="pt-3 pr-3">
              <v-list-tile-content></v-list-tile-content>
              <v-list-tile-action class="text--primary">
                <v-btn round class="pl-4 pr-4 text-none" @click="logout">Se déconnecter</v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-toolbar>
      </v-navigation-drawer>
    </div>
    <v-content class="white">
      <router-view></router-view>
    </v-content>
    <v-snackbar v-model="snackbar" class="snackbar--pwa grey--text text--darken-2" color="white" :timeout="0" multi-line vertical light bottom right dark>
      <div class="d-flex align-center subheading mb-2">
        <v-icon left medium>download</v-icon>
        Installer l'application
      </div>
      Ajouter l'application Mini CAQ sur votre écran d'accueil.
      <div class="d-flex mt-3">
        <v-btn class="mr-1" color="primary" @click="installPwa">
          Installer
        </v-btn>
        <v-btn color="primary" flat @click="snackbar = false">
          Fermer
        </v-btn>
      </div>
    </v-snackbar>
    <div class="grey lighten-5 footer"></div>
  </v-app>

</template>

<script>

import { Auth } from './auth';
import { Exchanger } from './exchanger';
import { nSQL } from "@nano-sql/core";

export default {
  name: 'App',
  data () {
    return {
      logo: require('@/assets/minicaq.svg'),
      user: {},
      drawer: false,
      currentSolicitationAssignation: {},
      authenticated: false,
      navItems: [
        { title: 'Mes campagnes', icon: 'assignment', path: '/my-campaigns' },
        { title: 'Pointage direct', icon: 'flag', path: '/my-direct-scoring' },
      ],
      snackbar: false,
      deferredPrompt: null,
    }
  },
  computed: {
    allowedNavItems() {
      const navItems = [];

      if (this.currentSolicitationAssignation.id) {
        navItems.push({title: 'Ma campagne en cours', subtitle: this.currentSolicitationAssignation.label, icon: 'star', path: '/my-current-campaign'})
      }

      for (let i = 0, len = this.navItems.length; i < len; i++) {
        navItems.push(this.navItems[i]);
      }

      return navItems;
    }
  },

  methods: {
    logout() {
      this.drawer = false;
      Auth.logout(this, '/login');
    },

    refreshUser() {
      this.authenticated = Auth.isAuthenticated();
      this.user = this.authenticated ? Auth.user() : {};

      this.refreshCurrentSolicitationAssignation();
    },

    autosetCurrentSolicitationAssignation() {
      nSQL('solicitation_assignations')
        .query("select")
        .where(["user_id", "=", this.user.id])
        .exec()
        .then(function (rows) {
          if (rows.length > 0) {
            Auth.setCurrentSolicitationAssignationId(rows[0].id);
          }
        }.bind(this));
    },

    refreshCurrentSolicitationAssignation: function () {
      if (this.authenticated) {
        const currentSolicitationAssignationPromise = Auth.getCurrentSolicitationAssignation();

        if (currentSolicitationAssignationPromise) {
          currentSolicitationAssignationPromise.then(function (currentSolicitationAssignation) {
            this.currentSolicitationAssignation = currentSolicitationAssignation || {};

            if (! currentSolicitationAssignation) {
              this.autosetCurrentSolicitationAssignation();
            }

          }.bind(this))
        }
      } else {
        this.currentSolicitationAssignation = {};
      }
    },

    handleAddToHomescreen(event) {
      // Prevent the mini-infobar from appearing on mobile
      event.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = event;
      // Update UI notify the user they can install the PWA
      this.snackbar = true;
      // This is to prevent `beforeinstallprompt` event that triggers again on `Add` or `Cancel` click
      // window.removeEventListener('beforeinstallprompt', this.fireAddToHomeScreenImpression);
    },

    installPwa() {
      // Hide the app provided install promotion
      this.snackbar = false;
      // Show the install prompt
      this.deferredPrompt.prompt();
      // We've used the prompt, and can't use it again, throw it away
      this.deferredPrompt = null;
    },
  },

  mounted() {
    window.addEventListener('beforeinstallprompt', this.handleAddToHomescreen);

    Auth.$on('logged-in', function () {
      this.refreshUser();
      Exchanger.pullSolicitationAssignations();
    }.bind(this));

    Auth.$on('logged-out', function () {
      this.refreshUser();
    }.bind(this));

    Auth.$on('current-solicitation-assignation-changed', function () {
      this.refreshCurrentSolicitationAssignation();
    }.bind(this));

    Exchanger.$on('solicitation-assignations-pulled', function () {
      this.refreshCurrentSolicitationAssignation();
    }.bind(this));

    this.refreshUser();
  }
}

</script>

<style>
  main {
    margin-top: constant(safe-area-inset-top); /* iOS 11.0 */
    margin-top: env(safe-area-inset-top);  /* iOS 11.2 */
    margin-right: constant(safe-area-inset-right); /* iOS 11.0 */
    margin-right: env(safe-area-inset-right); /* iOS 11.2 */
    margin-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
    margin-bottom: env(safe-area-inset-bottom); /* iOS 11.2 */
    margin-left: constant(safe-area-inset-left); /* iOS 11.0 */
    margin-left: env(safe-area-inset-left); /* iOS 11.2 */
  }
  .toolbar-app {
    padding-top: constant(safe-area-inset-top); /* iOS 11.0 */
    padding-top: env(safe-area-inset-top);  /* iOS 11.2 */
  }
  .toolbar-app .v-toolbar__content {
    margin-right: constant(safe-area-inset-right); /* iOS 11.0 */
    margin-right: env(safe-area-inset-right); /* iOS 11.2 */
    margin-left: constant(safe-area-inset-left); /* iOS 11.0 */
    margin-left: env(safe-area-inset-left); /* iOS 11.2 */
 }
  .navigation-logo {
    margin-top: constant(safe-area-inset-top); /* iOS 11.0 */
    margin-top: env(safe-area-inset-top); /* iOS 11.2 */
  }
  aside {
    padding-left: constant(safe-area-inset-left); /* iOS 11.0 */
    padding-left: env(safe-area-inset-left); /* iOS 11.2 */
  }
  aside a { text-decoration: none; }
  a.router-link-active { background:#dedede; }
  .footer {
    position:fixed;
    bottom:0;
    width:100%;
    height: constant(safe-area-inset-bottom); /* iOS 11.0 */
    height: env(safe-area-inset-bottom); /* iOS 11.2 */
    display:block;
  }
  .snackbar--pwa.v-snack--vertical .v-snack__content .v-btn.v-btn {
    padding: 8px;
    justify-content: center;
    margin-left: 0;
    margin-top: 0;
  }
  .snackbar--pwa.v-snack--vertical .v-snack__content {
    height: auto;
  }
  .snackbar--pwa .d-flex.subheading .v-icon {
    flex: initial !important;
  }
</style>
